@if (dropdownLabel) {
  <label class="trim-text">{{ dropdownLabel }}
    @if (errors?.['required']) {
      <small>*</small>
    }
  </label>
}
<ng-container *transloco="let t">
  @if (!isButton) {
    <app-dropdown (openChange)="multiselectDropdownOpenChange($event)" [openDropdownUpwards]="openDropdownUpwards"
                  [disabled]="disabled" [isDropdownListFullWidth]="isDropdownListFullWidth">
      <div dropdownPanel>
        <div class="form-control input-wrapper d-flex align-items-center justify-content-between py-1" dropdownToggle
             [ngClass]="{
                 'error': touched && invalid,
                    'ng-touched': touched,
                    'ng-invalid ': touched && invalid,
                    'disabled': disabled
                  }">
          <div class="form-floating">
            <div class="input-group">
              <div class="d-flex align-items-center ps-3">
                @if (formControlValue.length > 0) {
                  <div class="mt-1 d-flex align-items-center flex-row flex-wrap">
                    @for (item of selectedValues;track item) {
                      <div class="my-1">
                        <app-badge-with-button [badgeText]="options.get(item) ?? ''" [item]="item"
                                               (buttonAction)="onItemSelect(item)"/>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div dropdownContent id="multiselectDropdown">
        <ng-container [ngTemplateOutlet]="content">
        </ng-container>
      </div>
    </app-dropdown>

    @if (invalid && touched) {
      @for (errorMessage of errors | errorMessages;track errorMessage) {
        <span class="errorMes pt-1">{{ errorMessage }} </span>
      }

    }
  } @else {
    @if (!disabled) {
      <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
    <span class="menu-icon" ngbDropdownToggle [class.icon-table-heading]="isTableHeading" [ngClass]="iconClass">
      <i [ngClass]="buttonIconClass ?? 'fas fa-ellipsis-v'"></i>
    </span>
        <div ngbDropdownMenu>
          <ng-container [ngTemplateOutlet]="content">
          </ng-container>
        </div>
      </div>
    } @else {
      <div class="dropdown dropdown--remove-arrow disabled">
    <span class="menu-icon" [class.icon-table-heading]="isTableHeading" [ngClass]="iconClass">
      <i [class]="buttonIconClass ?? 'fas fa-ellipsis-v'"></i>
    </span>
      </div>
    }
  }

  <ng-template #content>
    <div class="multiselect-list-wrapper">
      @if (!maxItemsCount) {
        <div (click)="onSelectAll()" class="select-item">
          <div class="d-flex align-items-center">
            <input type="checkbox" (click)="onSelectAll()" class="custom-checkbox me-2"
                   [checked]="options && options.size === formControlValue.length"/>
            <div class="text-wrapper d-flex align-items-center w-100">
              <div class="flex-grow-1 py-2">
                <span class="fs-16">{{ t("app.common.all") | titlecase }}</span>
              </div>
            </div>
          </div>
        </div>
      } @else if (maxItemsCount < options.size) {
        <div class="p-2">
          <span> {{ t("multiselect.max.item", {value: maxItemsCount}) }}</span>
        </div>
      }
      @for (item of options.keys();track item) {
        <div (click)="onItemSelect(item)" class="select-item">
          <div class="d-flex align-items-center">
            <input type="checkbox" (click)="onItemSelect(item)" class="custom-checkbox me-2"
                   [checked]="isOptionSelected(item)"/>
            <div class="text-wrapper d-flex align-items-center w-100">
              <div class="multiselect-border-top flex-grow-1 py-2">
                <span class="fs-16">{{ options.get(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
</ng-container>
